import { useQuery } from "@tanstack/react-query";
import { getRelatedPosts } from "../../api/apiStorefront";
import i18next from "i18next";

/**
 * Hook to fetch related blog posts for a specific post
 * @param {string} slug - Post slug
 * @param {Object} params - Query parameters
 * @param {number} params.limit - Number of posts (default: 4)
 */
export function useGetRelatedPosts(slug, params = {}) {
    const {
        isLoading,
        data,
        error,
        refetch,
    } = useQuery({
        queryKey: ["relatedPosts", i18next.language, slug, params],
        queryFn: () => getRelatedPosts(slug, params),
        retry: false,
        enabled: !!slug, // Only run when slug is provided
        staleTime: 1000 * 60 * 10, // 10 minutes
        cacheTime: 1000 * 60 * 15, // 15 minutes
    });

    const posts = data?.data?.data || [];

    return { isLoading, error, posts, refetch };
}
